import clsx from 'clsx';

const dataAttr = (guard)=>{
    return guard ? "" : undefined;
};
const ariaAttr = (guard)=>{
    return guard ? "true" : undefined;
};
const elementProps = (props)=>props;
const inputProps = (props)=>props;
const labelProps = (props)=>props;
const buttonProps = (props)=>props;
const imgProps = (props)=>props;

const visuallyHidden = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
};

// Mostly based on:
// - react-aria
// - @zag-js/core
function mergeProps(...args) {
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    const result = {
        ...args[0]
    };
    for(let i = 1; i < args.length; i++){
        const props = args[i];
        for(const key in props){
            const a = result[key];
            const b = props[key];
            // Chain events
            if (typeof a === "function" && typeof b === "function" && key[0] === "o" && key[1] === "n" && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) {
                // While merging, we want to call the overriding function first.
                // Calling preventDefault in overriding function will prevent the default behavior of the base function.
                result[key] = chain(b, a);
            } else if (key === "className" && typeof a === "string" && typeof b === "string") {
                result[key] = clsx(a, b);
            } else if (key === "style") {
                result[key] = Object.assign({}, a ?? {}, b ?? {});
            } else {
                result[key] = b !== undefined ? b : a;
            }
        }
    }
    return result;
}
const chain = (...fns)=>(...p)=>{
        fns.forEach(function(fn) {
            fn?.(...p);
        });
    };

export { ariaAttr, buttonProps, dataAttr, elementProps, imgProps, inputProps, labelProps, mergeProps, visuallyHidden };
